module.exports = __webpack_public_path__ + "img/upload_logo.2703fd58.png";